import { CompactType, DisplayGrid, GridsterConfig, GridType } from 'angular-gridster2';

export const COL_WIDTH = 375;
export const COL_GAP = 32;
export const DOCKER_WIDTH = 48;

export const gridsterConfig: GridsterConfig = {
  setGridSize: true, // has to be se to show grid in layout
  disableWarnings: true, // disables warning for auto positioning because it is intended behaviour

  gridType: GridType.Fixed, // fixed size for fixed grid item size

  fixedColWidth: COL_WIDTH, // width in px as defined by the design
  fixedRowHeight: 300, // height in px as defined by the design

  addEmptyRowsCount: 1, // how many empty rows are added after the last filled row

  margin: COL_GAP, // margin between items as defined by the design
  outerMargin: false, // outer margin is not needed

  displayGrid: DisplayGrid.None, // hide grid in UI
  mobileBreakpoint: 0, // deactivate mobile view

  compactType: CompactType.CompactLeftAndUp, // allow Items only to be rearranged beside each other
  pushItems: true,
  draggable: {
    enabled: false, // enable drag & drop for widgets
    ignoreContent: true, // disable drag over whole content
    dragHandleClass: 'drag-header', // enable drag for this class. defined in cartridge-widget.component.ts
  },
  enableBoundaryControl: true, //does restrict drag & drop to dashboard
};
